import PaymentSource from '@square/dashboard-data/models/squareup/beemo/api/v2/models/payment-source';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  paymentSource: attr(PaymentSource)
});